// jsTree - is jquery plugin, that provides interactive trees: https://www.jstree.com/

// jquery
window.jQuery = window.$ = require('jquery');

// bootstrap
require('bootstrap');

require('jstree/dist/jstree.js');

require('./jstree.scss');
